// /plugins/vue-swiper.js文件

import Vue from 'vue'
import VueAwesomeSwiper from '~/ecosystem.config'

if (process.browser) {
    const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr')
    Vue.use(VueAwesomeSwiper)
}
